import ExportFile from './ExportFile'
export class ExportFileData {
    ExportFiles: ExportFile[];
}

export default ExportFileData;